// import Highcharts from "highcharts/highstock";
import CAMCFundTenHolding from "./camc-fund-ten-holding";

class WebsiteFundTenHolding extends CAMCFundTenHolding {
    constructor(fundCode) {
        super(fundCode, reportTime);
        this.$root = $(".tabs-content-amc.top-ten-holding");
    }

    setEmptyMessage(target = "#top-ten-holding-container", emptyMessage = "暂无数据显示") {
        let $targetObj = this.$root.find(target);
        if ($targetObj) {
            $targetObj.empty();
            $targetObj.append(`<div class="api-messaging-content grid-x align-center-middle">${emptyMessage}</div>`);
        }
    }

    errorHandler() {
        showApiMessageing(null);
        this.setEmptyMessage("#top-ten-holding-container");
    }

    updateFundDate(date) {
        this.$root.find(".container-updatetime-portfolio").text("数据截止日期：" + date);
    }

    generateEquityChart(equityDataArray) {
        var $legend = this.$root.find("#top-ten-holding-container-table").empty();
        if ($legend.length && equityDataArray.length) {
            $legend.find(".tabs-content-amc__table").removeClass("hide");
            let headerItem = `
                <div class="grid-x item-title">
                    <div class="cell small-2 large-3 series">序号</div>
                    <div class="cell small-2 medium-3 series series__title">股票代码</div>
                    <div class="cell small-2 large-3 series series__title">股票名称</div>
                    <div class="cell small-4 series series__title--mobile">股票名称/代码</div>
                    <div class="cell small-2 medium-4 large-3 series series__percent">占基金资产净值比例</div>
                </div>
            `;
            $legend.append(headerItem);
            equityDataArray.forEach(function (element, index) {
                let contentItem = `
                    <div class="grid-x item">
                            <div class="cell small-2 large-3 series">${element.seqNo}</div>
                            <div class="cell small-2 medium-3 series series__item">${
                                element.securitiesCode || "-"
                            }</div>
                            <div class="cell small-6 medium-5 large-3 series series__item">${element.name}</div>
                            <div class="cell small-8 series series__item--mobile">
                                <div class="complex__item">${element.name}</div>
                                <div class="complex__item">${element.securitiesCode || "-"}</div>
                            </div>
                            <div class="cell small-2 large-3 series series__item--percent text-right">
                                ${Highcharts.numberFormat(element.fundWt).replace(",", " ")}%
                            </div>
                    </div>
                `;
                $legend.append(contentItem);
            });
        } else {
            $legend.remove();
            if (this.reportTime) {
                this.setEmptyMessage(".empty-message", "<span>本基金本报告期末</span><span>未持有股票</span>");
            } else {
                this.setEmptyMessage(".empty-message");
            }
        }
    }
}

$(function () {
    if (window.fundCode && $(".fund-portfolio-div .top-ten-holding").length) {
        const camcFundTenHolding = new WebsiteFundTenHolding(window.fundCode);
        camcFundTenHolding.render();
    }
});
